import { toast } from "../components/razor-reuse";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../utils/axios";
import { AuthState } from "./type";

interface LoginPayload {
  // Add appropriate types for the payload admin/logged-in-details
}

export const loginUser = createAsyncThunk(
  "web/login_admin",
  async (payload: LoginPayload, thunkAPI) => {
    try {
      const data = await axios.post("/admin/login", payload);

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        // toast.success(data?.data?.message, {
        //   position: "top-right",
        //   theme: "colored",
        // });
        const obj = data?.data?.data;

        // localStorage.setItem("token", String(obj.token)); // Commenting this because of the MFA Logic
        thunkAPI.dispatch(SET_TOKEN(obj?.token)); // Testing this flow for MFA Token
        return data?.data;
      }
      return data;
    } catch (error: any) {
      console.log(error);

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  }
);

export const logoutUser = createAsyncThunk(
  "web/logout_admin",
  async (payload: LoginPayload, thunkAPI) => {
    try {
      const data = await axios.post("/admin/logout", payload);

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        toast.success(data?.data?.message, {
          position: "top-right",
          theme: "colored",
        });

        return data;
      }
      return data;
    } catch (error: any) {

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  }
);

export const verifyInvitedAdmin = createAsyncThunk(
  "web/verify-user-admin-invited",
  async (payload: LoginPayload, thunkAPI) => {
    try {
      const data = await axios.post("/admin/verifyInvitedAdmin", payload);

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          // toast.error(data.data);
        }
        // toast.error(data?.data?.message, {
        //   position: "top-right",
        // });
        else return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.success) {
        toast.success(data?.data?.message, {
          position: "top-right",
          theme: "colored",
        });

        // SET_TOKEN(data.data.data.token);
        // localStorage.setItem('token', data.data.data.token);
        return data;
      }
      return data;
    } catch (error: any) {

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  }
);

export const forgotPasswordAdmin = createAsyncThunk(
  "web/forgot-password-admin-invited",
  async (payload: LoginPayload, thunkAPI) => {
    try {
      const data = await axios.post("/admin/password/forgot", payload);

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
        }
        // toast.error(data?.data?.message, {
        //   position: "top-right",
        // });
        else return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.success) {
        toast.success(data?.data?.message, {
          position: "top-right",
          theme: "colored",
        });

        // SET_TOKEN(data.data.data.token);
        // localStorage.setItem('token', data.data.data.token);
        return data;
      }
      return data;
    } catch (error: any) {

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  }
);

export const verifyOtpforgotPasswordAdmin = createAsyncThunk(
  "web/verify-otp-forgot-password-admin-invited",
  async (payload: LoginPayload, thunkAPI) => {
    try {
      const data = await axios.post("/admin/otp/verify", payload);

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
        }
        // toast.error(data?.data?.message, {
        //   position: "top-right",
        // });
        else return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.success) {
        toast.success(data?.data?.message, {
          position: "top-right",
          theme: "colored",
        });

        // SET_TOKEN(data.data.data.token);
        // localStorage.setItem('token', data.data.data.token);
        return data;
      }
      return data;
    } catch (error: any) {
  

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  }
);

export const getLoggedInUser = createAsyncThunk(
  "web/get-logged-in-user-info",
  async (payload: any, thunkAPI) => {
    try {
      const data = await axios.get(`/admin/logged-in-details`);

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        const obj = data?.data?.data?.user;
        thunkAPI.dispatch(SET_USER(obj));
        return data;
      }
      return data;
    } catch (error: any) {

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  }
);

export const resetPasswordAdmin = createAsyncThunk(
  "web/reset-password-admin-invited",
  async (payload: LoginPayload, thunkAPI) => {
    try {
      const data = await axios.post("/admin/password/reset", payload);
      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          // toast.error(data.data);
        }
        // toast.error(data?.data?.message, {
        //   position: "top-right",
        // });
        else return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.success) {
        toast.success(data?.data?.message, {
          position: "top-right",
          theme: "colored",
        });

        // SET_TOKEN(data.data.data.token);
        // localStorage.setItem('token', data.data.data.token);
        return data;
      }
      return data;
    } catch (error: any) {
      console.log(error);

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  }
);

export const resendOtpAdmin = createAsyncThunk(
  "web/resend-otp-admin",
  async (payload: LoginPayload, thunkAPI) => {
    try {
      const data = await axios.post("/admin/otp/resend", payload);

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          // toast.error(data.data);
        }
        // toast.error(data?.data?.message, {
        //   position: "top-right",
        // });
        else return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.success) {
        toast.success(data?.data?.message, {
          position: "top-right",
          theme: "colored",
        });

        // SET_TOKEN(data.data.data.token);
        // localStorage.setItem('token', data.data.data.token);
        return data;
      }
      return data;
    } catch (error: any) {

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  }
);

export const confirmInvitedAdminFunc = createAsyncThunk(
  "web/confirm-user-admin-invited",
  async (payload: LoginPayload, thunkAPI) => {
    try {
      const data = await axios.post("/admin/complete-admin-signup", payload);

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          // toast.error(data.data);
        }
        // toast.error(data?.data?.message, {
        //   position: "top-right",
        // });
        else return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.success) {
        toast.success(data?.data?.message, {
          position: "top-right",
          theme: "colored",
        });

        // SET_TOKEN(data.data.data.token);
        // localStorage.setItem('token', data.data.data.token);
        return data;
      }
      return data;
    } catch (error: any) {

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  }
);

export const requestOtpForgetPassword = createAsyncThunk(
  "web/request-otp-password",
  async (payload: LoginPayload, thunkAPI) => {
    try {
      const data = await axios.post("/admin/confirm-email", payload);

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.success) {
        toast.success(data?.data?.message, {
          position: "top-right",
          theme: "colored",
        });

        // SET_TOKEN(data.data.data.token);
        // localStorage.setItem('token', data.data.data.token);
        return data;
      }
      return data;
    } catch (error: any) {
      console.log(error);

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  }
);

export const changePassword = createAsyncThunk(
  "web/change-password",
  async (payload: LoginPayload, thunkAPI) => {
    try {
      const data = await axios.post("/admin/reset-password", payload);

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.success) {
        toast.success(data?.data?.message, {
          position: "top-right",
          theme: "colored",
        });

        // SET_TOKEN(data.data.data.token);
        // localStorage.setItem('token', data.data.data.token);
        return data;
      }
      return data;
    } catch (error: any) {
      console.log(error);

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  }
);

export const submitOtpForgetPassword = createAsyncThunk(
  "web/submit-otp-password",
  async (payload: LoginPayload, thunkAPI) => {
    try {
      const data = await axios.post("/admin/verify-password-otp", payload);

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.success) {
        toast.success(data?.data?.message, {
          position: "top-right",
          theme: "colored",
        });

        // SET_TOKEN(data.data.data.token);
        // localStorage.setItem('token', data.data.data.token);
        return data;
      }
      return data;
    } catch (error: any) {
      console.log(error);

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  }
);

const initialState: AuthState = {
  loading: false,
  isAuth: false,
  logging_out: false,
  loading_user: false,
  loading_logout: false,
  token: "",
  user: {},
  // initialize other state properties
};

export const authSlice = createSlice({
  name: "auth",
  initialState,

  reducers: {
    LOGIN: (state, action) => {
      state.user = action.payload;
      state.isAuth = true;
    },
    SET_TOKEN: (state, action) => {
      state.token = action.payload;
    },
    SET_USER: (state, action) => {
      state.user = action.payload;
    },
    LOGOUT: (state, action) => {
      state.logging_out = action.payload;
      state.isAuth = true;
    },
  },

  extraReducers: (builder) => {
    // pending state changes
    builder.addCase(verifyInvitedAdmin.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(verifyInvitedAdmin.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(verifyInvitedAdmin.rejected, (state) => {
      state.loading = false;
      return initialState;
    });
    builder.addCase(resetPasswordAdmin.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(resetPasswordAdmin.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(resetPasswordAdmin.rejected, (state) => {
      state.loading = false;
      return initialState;
    });
    builder.addCase(verifyOtpforgotPasswordAdmin.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(verifyOtpforgotPasswordAdmin.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(verifyOtpforgotPasswordAdmin.rejected, (state) => {
      state.loading = false;
      return initialState;
    });
    builder.addCase(confirmInvitedAdminFunc.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(confirmInvitedAdminFunc.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(confirmInvitedAdminFunc.rejected, (state) => {
      state.loading = false;
      return initialState;
    });
    builder.addCase(forgotPasswordAdmin.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(forgotPasswordAdmin.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(forgotPasswordAdmin.rejected, (state) => {
      state.loading = false;
      return initialState;
    });
    builder.addCase(resendOtpAdmin.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(resendOtpAdmin.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(resendOtpAdmin.rejected, (state) => {
      state.loading = false;
      return initialState;
    });
    builder.addCase(loginUser.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(loginUser.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(loginUser.rejected, (state) => {
      state.loading = false;
      return initialState;
    });
    builder.addCase(requestOtpForgetPassword.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(requestOtpForgetPassword.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(requestOtpForgetPassword.rejected, (state) => {
      state.loading = false;
      return initialState;
    });
    builder.addCase(submitOtpForgetPassword.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(submitOtpForgetPassword.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(submitOtpForgetPassword.rejected, (state) => {
      state.loading = false;
      return initialState;
    });
    builder.addCase(changePassword.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(changePassword.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(changePassword.rejected, (state) => {
      state.loading = false;
      return initialState;
    });
    builder.addCase(getLoggedInUser.pending, (state) => {
      state.loading_user = true;
    });
    builder.addCase(getLoggedInUser.fulfilled, (state) => {
      state.loading_user = false;
    });
    builder.addCase(getLoggedInUser.rejected, (state) => {
      state.loading_user = false;
      return initialState;
    });
    builder.addCase(logoutUser.pending, (state) => {
      state.loading_logout = true;
    });
    builder.addCase(logoutUser.fulfilled, (state) => {
      state.loading_logout = false;
    });
    builder.addCase(logoutUser.rejected, (state) => {
      state.loading_logout = false;
      return initialState;
    });
  },
});

// Action creators are generated for each case reducer function
export const { LOGIN, LOGOUT, SET_TOKEN, SET_USER } = authSlice.actions;

export default authSlice.reducer;
